import { useBreakpointValue } from '@chakra-ui/react';
import { ResponsiveBreakpoint } from './types';

type ResponsiveConfig = {
    enabled?: boolean;
    mobileBreakpoint?: ResponsiveBreakpoint;
    defaultView?: 'grid' | 'cards' | 'auto';
};

const BREAKPOINT_ORDER: ResponsiveBreakpoint[] = ['base', 'sm', 'md', 'lg', 'xl', '2xl'];

function buildBreakpointMap(mobileBreakpoint: ResponsiveBreakpoint): Record<string, boolean> {
    const map: Record<string, boolean> = {};
    let foundBreakpoint = false;
    for (const bp of BREAKPOINT_ORDER) {
        if (bp === mobileBreakpoint) {
            foundBreakpoint = true;
        }
        // Below the breakpoint → cards (true), at/above → grid (false)
        map[bp] = !foundBreakpoint;
    }
    return map;
}

export function useResponsiveGridMode(responsive?: ResponsiveConfig): 'grid' | 'cards' {
    const mobileBreakpoint = responsive?.mobileBreakpoint ?? 'md';
    const breakpointMap = buildBreakpointMap(mobileBreakpoint);

    const isMobile = useBreakpointValue(breakpointMap, { ssr: false });

    if (responsive?.enabled === false) {
        return 'grid';
    }

    if (responsive?.defaultView === 'grid') {
        return 'grid';
    }

    if (responsive?.defaultView === 'cards') {
        return 'cards';
    }

    // 'auto' or undefined
    return isMobile ? 'cards' : 'grid';
}
